export default __webpack_public_path__ + "static/theme-a16a65b517b550a980d9402d537390c2.mp4";